import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { faPaperPlane, faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { EntryService } from './entry.service';
import { Entry } from './entry';
import { GeocoderResponse } from './GeocodeResponse'
import { StoreLocation } from './storeLocation';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'entry',
    templateUrl: './entry.component.html',
    styleUrls: ['./entry.component.scss'],
    standalone: false
})
export class EntryComponent implements OnInit {
    @Input() contestId!: number;
    @Input() hasLocations!: boolean;
    @Input() contestMessage!: string;
    @Input() contestAttemptId!: number;
    @ViewChild('entryForm') form!: NgForm;
    entry!: Entry;
    stores: StoreLocation[] = [];
    faPaperPlane = faPaperPlane;
    faLocationDot = faLocationDot;
    isSubmitting: boolean = false;
    recaptchaError: string = '';
    submissionError: string = '';
    recaptchaSiteKey: string = environment.recaptcha.siteKey;

    constructor(
        public entryService: EntryService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router
    ) {

    }

    ngOnInit() {

        this.entry = this._activatedRoute.snapshot.params['entry'];

        this.entry = {
            entryId: 0,
            emailaddress: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            contestId: this.contestId,
            firstName: "",
            lastName: "",
            optin: false,
            phone: "",
            state: "",
            invisibleToken: "",
            contestAttemptId: this.contestAttemptId,
        };
        if (this.hasLocations)
            this.getLocation();
    }

    getLocation() {
        var zipDefault = "";
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position) {
                    var lat = position.coords.latitude;
                    var long = position.coords.longitude;
                    var latlng = new google.maps.LatLng(lat, long)
                    let geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'location': latlng }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK && results) {
                            for (var i = 0; i < results[0].address_components.length; i++) {
                                if (results[0].address_components[i].types[0] === "postal_code") {
                                    zipDefault = results[0].address_components[i].short_name;
                                }
                            }

                        }
                    }).then((success) => {
                        this.entry.zip = Number(zipDefault);
                        if (this.entry.zip != 0) {
                            this.getStores();
                        }
                    });
                }
            },
                (error) => console.log(error));
        } else {
            alert("Geolocation is not supported by this browser.");
        }

    }

    onSubmit() {
        // Clear previous errors
        this.recaptchaError = '';
        this.submissionError = '';

        // if form not valid set inputs
        if (!this.form.valid) {
            this.form.form.markAllAsTouched();
        } else {
            this.addEntry(this.entry);
        }
        // else run the add entry function
    };

    addEntry(data: any) {
        // Validate reCAPTCHA v2 token exists
        if (!this.entry.invisibleToken) {
            this.recaptchaError = 'Please complete the reCAPTCHA challenge.';
            return;
        }

        // Set loading state
        this.isSubmitting = true;

        // Clean phone number
        this.entry.phone = this.entry.phone.replaceAll('-', '').replace('(', '').replace(')', '').replaceAll(' ', '').replaceAll('.', '');

        this.entryService.createEntry(this.entry).subscribe({
            next: (response) => {
                window.location.href = response.responseUrl;
            },
            error: (error) => {
                this.isSubmitting = false;
                console.error('Entry submission error:', error);

                // Check if it's a reCAPTCHA error
                if (error.error?.message?.includes('robot') || error.error?.message?.includes('recaptcha')) {
                    this.recaptchaError = 'reCAPTCHA verification failed. Please complete the challenge and try again.';
                } else {
                    this.submissionError = error.error?.message || 'An error occurred while submitting your entry. Please try again.';
                }
            }
        });
    }

    // Handle reCAPTCHA v2 success
    onCaptchaResolved(captchaResponse: string | null): void {
        if (captchaResponse) {
            this.entry.invisibleToken = captchaResponse;
            this.recaptchaError = '';
        } else {
            this.entry.invisibleToken = '';
            this.recaptchaError = 'reCAPTCHA verification failed. Please try again.';
        }
    }

    // Handle reCAPTCHA v2 error
    onCaptchaError(): void {
        this.recaptchaError = 'reCAPTCHA error occurred. Please try again.';
        this.entry.invisibleToken = '';
    }

    // Handle reCAPTCHA v2 expiration
    onCaptchaExpired(): void {
        this.recaptchaError = 'reCAPTCHA expired. Please verify again.';
        this.entry.invisibleToken = '';
    }

    getStores() {
        this.stores = [];
        this.entryService
            .getLocation(this.entry.zip!.toString())
            .subscribe(
                (response: GeocoderResponse) => {
                    console.log(response);
                    if (response.status === 'OK' && response.results?.length) {
                        const location = response.results[0];
                        const loc: any = location.geometry.location;
                        console.log(loc);
                        this.entryService.getStores(this.contestId, loc.lng, loc.lat)
                            .subscribe(x => {
                                console.log(x);
                                this.stores = x;
                                this.entry.storeLocationId = x[0].storeLocationId.toString();
                            });
                    } 
                    // else {
                    //     this.entryService.getStore(this.contestId, this.entry.zip!.toString())
                    //         .subscribe((storeLocation: StoreLocation) => {
                    //             const lng = storeLocation.longitude;
                    //             const lat = storeLocation.latitude;
                    //             this.entryService.getStores(this.contestId, lng, lat)
                    //                 .subscribe(x => {
                    //                     console.log(x);
                    //                     this.stores = x;
                    //                     this.entry.storeLocationId = x[0].storeLocationId.toString();
                    //                 });
                    //         });
                    // }
                },
            );
    }

    update(e: any) {
        this.entry.storeLocationId = e.target.value;
    }
}

